(() => {
  const sections = document.querySelectorAll('[data-hk-hscroll]');
  if (!sections.length) return;

  const clamp = (v, min, max) => Math.min(Math.max(v, min), max);
  let items = [];

  function rebuild() {
    items = [];
    sections.forEach((section) => {
      const track = section.querySelector('[data-hk-hscroll-track]');
      const row = section.querySelector('.hk-row');
      if (!track || !row) return;

      // 横移動量
      const totalX = Math.max(0, row.scrollWidth - window.innerWidth);

      // 横移動量ぶん縦スクロール区間を確保
      section.style.height = `calc(100vh + ${totalX}px)`;

      // 念のため：Y移動を残さない
      track.style.transform = 'translate3d(0,0,0)';

      items.push({ section, track, totalX });
    });
  }

  function onScroll() {
    items.forEach(({ section, track, totalX }) => {
      const rect = section.getBoundingClientRect();
      const progress = clamp(-rect.top, 0, totalX);

      // ★横だけ
      track.style.transform = `translate3d(${-progress}px, 0, 0)`;
    });
  }

  let ticking = false;
  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => { onScroll(); ticking = false; });
  }, { passive: true });

  window.addEventListener('resize', () => { rebuild(); onScroll(); });
  window.addEventListener('load', () => { rebuild(); onScroll(); });

  rebuild();
  onScroll();
})();
